import { HeartHandshake, Sparkles, LayoutDashboard, Receipt, PhoneCall, CalendarClock, MailX, AlertTriangle } from 'lucide-react';
import { NavItem } from '../types';

const customersItems: NavItem[] = [
  {
    title: 'Customers',
    icon: HeartHandshake,
    path: '/app/customers/reengage',
    requiredPermissions: ['customer.read'],
    children: [
      { title: 'Re-Engage', path: '/app/customers/reengage', icon: Sparkles, requiredPermissions: ['customer.read'] },
      { title: 'Finance Overview', path: '/app/customers/finance', icon: LayoutDashboard, requiredPermissions: ['customer_finance.read'] },
      { title: 'Due Report', path: '/app/customers/dues', icon: Receipt, requiredPermissions: ['customer_finance.read'] },
      { title: 'Collections', path: '/app/customers/collections', icon: PhoneCall, requiredPermissions: ['customer_collections.read'] },
      { title: 'Aging', path: '/app/customers/aging', icon: CalendarClock, requiredPermissions: ['customer_finance.read'] },
      { title: 'Unsent Invoices', path: '/app/customers/unsent', icon: MailX, requiredPermissions: ['customer_finance.read'] },
      { title: 'Alerts', path: '/app/customers/alerts', icon: AlertTriangle, requiredPermissions: ['customer_finance.read'] },
    ],
  },
];

export default customersItems;
